

import { Vue, Component, Prop } from 'vue-property-decorator'
import FiFreeDelivery48Svg from '~/svg/fi-free-delivery-48.svg'
import Fi24Hours48Svg from '~/svg/fi-24-hours-48.svg'
import FiPaymentSecurity48Svg from '~/svg/fi-payment-security-48.svg'
import FiTag48Svg from '~/svg/fi-tag-48.svg'
import sysPageApi from '~/api/syspage'

type BlockFeaturesLayout = 'classic' | 'boxed'

@Component({
    components: { FiFreeDelivery48Svg, Fi24Hours48Svg, FiPaymentSecurity48Svg, FiTag48Svg }
})
export default class BlockFeatures extends Vue {
    @Prop({ type: String, default: () => 'classic' }) layout!: BlockFeaturesLayout

    data1: any = null
    data2: any = null
    data3: any = null
    data4: any = null

    async mounted() {
        this.data1 = await sysPageApi.getByPageName('block1')
        this.data2 = await sysPageApi.getByPageName('block2')
        this.data3 = await sysPageApi.getByPageName('block3')
        this.data4 = await sysPageApi.getByPageName('block4')
    }
}

